import * as OBC from "@thatopen/components";
import * as OBCF from "@thatopen/components-front";
import * as THREE from "three";

export function AddMeasurment(components: OBC.Components, world: OBC.World) {
    const dimensions = components.get(OBCF.LengthMeasurement);
    dimensions.world = world;
    dimensions.enabled = true;
    dimensions.snapDistance = 0.1;
    return dimensions;
}